import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./Navbar";
import Home from "./Home";
import Create from "./Create";
import BlogDetails from "./BlogDetails";
import NotFound from "./NotFound";

function App() {
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedBlogs = localStorage.getItem("blogs");

    if (storedBlogs) {
      setBlogs(JSON.parse(storedBlogs));
      setIsLoading(false);
    } else {
      fetch(process.env.PUBLIC_URL + "/db.json")
        .then((res) => res.json())
        .then((data) => {
          setBlogs(data.blogs);
          setIsLoading(false);
        });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("blogs", JSON.stringify(blogs));
  }, [blogs]);

  const handleReset = () => {
    localStorage.removeItem("blogs");

    fetch(process.env.PUBLIC_URL + "/db.json")
      .then((res) => res.json())
      .then((data) => {
        setBlogs(data.blogs || data);
        setIsLoading(false);
      });
  };

  return (
    <Router basename="/dojo-blog">
      <div className="App">
        <Navbar handleReset={handleReset} />
        <div className="content">
          <Routes>
            <Route
              path="/"
              element={<Home blogs={blogs} isLoading={isLoading} />}
            />
            <Route path="/create" element={<Create setBlogs={setBlogs} />} />
            <Route
              path="/blogs/:id"
              element={<BlogDetails blogs={blogs} setBlogs={setBlogs} />}
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
